import { Alert, AlertProps, AlertTitle, Typography } from '@mui/material';
import { OxCategoriesNames } from '@oxappsec/ox-consolidated-categories';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { AppPages } from '../../common/routing/app-navigator';

const NoConnectivityBanner: FC<NoConnectivityBannerProps> = ({
  ...restOfProps
}) => {
  return (
    <Alert severity='error' {...restOfProps}>
      <AlertTitle>No Source Control Connectivity</AlertTitle>
      <Typography variant='body1' color='text.primary'>
        Please configure one Source Control connector with a valid token in
        the&nbsp;
        <NavLink
          to={`${AppPages.Connectors}?search=${OxCategoriesNames.SourceControl}`}>
          Connectors page
        </NavLink>
        .
      </Typography>
    </Alert>
  );
};

interface NoConnectivityBannerProps extends AlertProps {}
export default NoConnectivityBanner;
